module.exports = __webpack_public_path__ + "media/dz_bodzavirag_m.6b2503a8.mp3";